function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToss = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 145.01612,828.09018 H 253.61127 V 515.86942 H 145.01612 Z M 742.28944,541.88781 c 0,-28.62024 -24.43392,-52.03679 -54.29758,-52.03679 H 516.68302 l 25.79134,-118.90408 0.81447,-8.32588 c 0,-10.66754 -4.61529,-20.55454 -11.94547,-27.57951 L 502.56564,307.72224 323.92662,479.18348 c -10.04504,9.36661 -16.01777,22.37581 -16.01777,36.68594 v 260.18396 c 0,28.62024 24.4339,52.0368 54.29757,52.0368 H 606.5455 c 22.53349,0 41.80913,-13.0092 49.95376,-31.74245 l 81.98934,-183.4297 c 2.44339,-5.98423 3.80084,-12.22864 3.80084,-18.99343 z",
    id: "path479",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 555.18673,257.87844 c 1.61873,19.40496 17.83689,33.5008 35.74199,34.69109 12.30633,0.93916 15.30277,20.14917 2.8367,16.46194 -28.22362,-7.02711 -50.10916,-26.95306 -53.62405,-49.18977 -3.97992,-30.49982 16.34715,-58.24015 45.45994,-62.03908 l 13.63947,-1.77982 3.47231,10.23597 -15.05498,7.30604 c -20.79851,10.09332 -34.16765,23.97908 -32.47138,44.31363 z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#f90"
    },
    cx: -705.60864,
    cy: 343.06662,
    rx: 148.30508,
    ry: 78.389832,
    transform: "rotate(-135)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToss);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/toss.65e3ad39c8aaf33b960d9ece9aea3420.svg";